import { Box, Button, Grid } from '@mui/material';

interface IProps {
  currentStep: number;
  isStepComplete: (step: number) => boolean;
  previousStepsComplete: boolean;
  onCompleteStep: (step: number) => void;
  onCompleteOnboarding: () => Promise<void>;
  onSetActiveStep: (step: number | ((prev: number) => number)) => void;
  onNavigateBusiness: () => void;
}

export const StepActions: React.FC<IProps> = ({
  currentStep,
  isStepComplete,
  previousStepsComplete,
  onCompleteStep,
  onCompleteOnboarding,
  onSetActiveStep,
  onNavigateBusiness,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={2}>
        {/* Step 4: botão de publicar */}
        {currentStep === 4 && previousStepsComplete && (
          <Grid item>
            <Button
              variant="contained"
              onClick={async () => {
                await onCompleteOnboarding();
                // O componente OnboardingComplete será exibido após o re-render
              }}
            >
              Publicar página 🚀
            </Button>
          </Grid>
        )}

        {/* Step 4: passos incompletos — só navega para o painel */}
        {currentStep === 4 && !previousStepsComplete && (
          <Grid item>
            <Button variant="outlined" onClick={onNavigateBusiness}>
              Ir para o painel
            </Button>
          </Grid>
        )}

        {/* "Próximo Passo" — não aparece no step 4 (usa Publicar) */}
        {currentStep !== 4 && isStepComplete(currentStep) && (
          <Grid item>
            <Button variant="outlined" onClick={() => onCompleteStep(currentStep)}>
              Próximo Passo
            </Button>
          </Grid>
        )}

        {/* "Pular por enquanto" — não aparece no step 4 */}
        {currentStep !== 4 && !isStepComplete(currentStep) && (
          <Grid item>
            <Button variant="text" onClick={() => onCompleteStep(currentStep)}>
              Pular por enquanto
            </Button>
          </Grid>
        )}

        {/* "Não quero cadastrar" — específico Produtos */}
        {currentStep === 2 && !isStepComplete(currentStep) && (
          <Grid item>
            <Button variant="outlined" color="primary" onClick={() => onCompleteStep(2)}>
              Não quero cadastrar nenhum produto
            </Button>
          </Grid>
        )}

        {/* "Passo anterior" — disponível nos steps 1-5 */}
        {currentStep > 0 && (
          <Grid item>
            <Button variant="text" onClick={() => onSetActiveStep(prev => prev - 1)}>
              Passo anterior
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
